import { Col, Container, Row } from '@geberit/gdds';

// components
import { Title } from '../Title/Title';
import { MiVideoContainer } from 'components/Video/miVideo/MiVideoContainer';
import ConfigurableYoutube from 'components/Video/youtube/configurable-youtube';

// utils
import { useGdds } from 'utils/hooks/use-gdds';
import { useSectionId } from 'utils/hooks/use-section-id';
import { getTitleFormat } from './utils';

export type VideoContentProps = {
  title: string;
  subtitle: string;
  anchor: string;
  contentIndex: number;
  titleInAnchor: boolean;
  isSectionReference: boolean;
  isChild: boolean;
  border: string;
  video: {
    type: string;
    videoId: string;
    subscribeBtn: boolean;
    playerControl: boolean;
    language: string;
    showLink: boolean;
  };
};

export function VideoContent({
  titleInAnchor,
  isSectionReference,
  isChild,
  ...content
}: Readonly<VideoContentProps>) {
  const { contentIndex, title, subtitle, anchor, border, video } = content;
  const isGdds = useGdds();
  const sectionId = useSectionId(title, anchor, titleInAnchor, contentIndex);
  const borderClass = border === 'disable-border' ? `c-video-content__border--${border}` : '';

  return (
    <Container maxContentWidth={isGdds ? '78rem' : '80rem'}>
      <Row>
        <Col>
          <div className="c-video-content" id={sectionId}>
            <div>
              <Title
                title={title}
                subtitle={subtitle}
                Format={getTitleFormat(isGdds, isChild)}
                titlePreviewId="#st_title"
                subtitlePreviewId="#st_subtitle"
                isSectionReference={isSectionReference}
                formatClassName={isGdds ? undefined : 'h3'}
              />
            </div>
            {video?.type === 'youtube' ? (
              <ConfigurableYoutube
                videoId={video.videoId}
                playerControl={video.playerControl}
                language={video.language}
                showLink={video.showLink}
              />
            ) : (
              <MiVideoContainer
                content={content}
                className="c-video-content"
                isSectionReference={isSectionReference}
                isVideoContent
              />
            )}
            <div className={`c-video-content__border ${borderClass} grid-container`} />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
